const API_BASE = "/api";

export async function fetchNL2BLTLExamples() {
  try {
    const res = await fetch(`${API_BASE}/nl2bltl/examples`);
    if (res.ok) {
      const data = await res.json();
      return data.examples || [];
    }
  } catch (err) {
    console.error("NL2BLTL examples unavailable:", err);
  }
  return [];
}

async function errorMessage(res, fallback) {
  const data = await res.json().catch(() => ({}));
  return data.detail || data.error || `${fallback}: ${res.status}`;
}

export async function analyzeNL2BLTL(text) {
  const res = await fetch(`${API_BASE}/nl2bltl/analyze`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) {
    throw new Error(await errorMessage(res, "NL2BLTL analysis failed"));
  }
  const data = await res.json();
  return data.analysis || data;
}

export async function translateNL2BLTL({
  text,
  mode,
  behaviorText,
  variables,
  timeBounds,
}) {
  try {
    const res = await fetch(`${API_BASE}/nl2bltl/translate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        text,
        mode,
        behavior_text: behaviorText,
        variables,
        time_bounds: timeBounds,
      }),
    });
    if (res.ok) {
      const data = await res.json();
      return data.result || data;
    }
    const message = await errorMessage(res, "NL2BLTL backend error");
    return {
      input: text,
      preprocessed_input: text,
      variables: [],
      time_bounds: [],
      bltl: "",
      method: "unavailable",
      preview: null,
      error: message,
    };
  } catch (err) {
    console.error("NL2BLTL backend unreachable:", err);
  }
  return {
    input: text,
    preprocessed_input: text,
    variables: [],
    time_bounds: [],
    bltl: "",
    method: "unavailable",
    preview: null,
    error: "NL2BLTL service is unavailable.",
  };
}
